import supabaseClient from '@/api/supabaseClient.ts';
import { SubjectRepository as SharedSubjectRepository } from '$/repositories/subjectRepository/SubjectRepository.ts';

const subjectRepository = new SharedSubjectRepository(supabaseClient);
export default subjectRepository;
